import PropTypes from "prop-types";
import React from "react";

const TagDismissible = (props) => {
  const { label = "", tag, handleDeleteTag, size = "md" } = props;

  let tagClassName = "fr-tag fr-tag--dismiss";
  if (size === "sm") {
    tagClassName += " fr-tag--sm";
  }

  return (
    <button
      type="button"
      className={tagClassName}
      aria-label={`Supprimer le tag ${tag}`}
      onClick={() => handleDeleteTag(tag)}
    >
      {label}
      {tag}
    </button>
  );
};

TagDismissible.propTypes = {
  label: PropTypes.string,
  tag: PropTypes.string.isRequired,
  handleDeleteTag: PropTypes.func.isRequired,
  size: PropTypes.oneOf(["sm", "md"]),
};

export default TagDismissible;
